import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createSmsSignupTemplates = {
  name: "createSmsSignupTemplates" as const,
  input: z.object({ automationName: z.string() }),
  output: z.object({
    signupTemplateId: zExt.objectId(),
    welcomeTemplateId: zExt.objectId(),
  }),
};
